<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button></ion-back-button>
    </ion-buttons>
    
    <ion-title>Privacy Policy</ion-title>
    <ion-buttons *ngIf="mandatoryRead" slot="end">
      <ion-button (click)="modalController.dismiss()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  
  <div *ngIf="group.custom_privacy && gprivacy" [innerHTML]="gprivacy.contents"></div>

  <div *ngIf="!group.custom_privacy">
    <h3>INFORMATIVA SUL TRATTAMENTO DEI DATI PERSONALI</h3>
  <p>Gentilissimo/a,</p>
  <p>{{group.legal_name}} (di seguito il “Titolare”) in qualità di Titolare del trattamento dei dati personali, con la
    presente comunicazione desidera informarla su come tratterà i suoi dati personali, nello specifico quelli
    riguardanti la loro correlazione con l’utilizzo dei servizi proposti, in conformità con quanto disposto dall’art. 13
    e 14 del “Regolamento Europeo 2016/679, relativo alla protezione delle persone fisiche con riguardo al trattamento
    dei dati personali, nonché alla libera circolazione di tali dati” (da ora in poi GDPR o Regolamento) che ne prevede
    la tutela, ed ai sensi del quale le comunichiamo quanto di seguito indicato.
    Specifichiamo che la presente Informativa le viene resa esclusivamente per il segmento di 2° livello
    dell’applicazione Tempo (a seguire “App” o “Tempo”) di cui la scrivente è Autonomo Titolare del trattamento, mentre
    per quanto riguarda il trattamento dei dati personali c.d. “di base” riguardanti la gestione dell’account utente e
    del wallet, presenti nel 1° livello dell’applicazione il Titolare del trattamento rimane Tempo 2050 S.r.l.</p>

  <h3>1. Fonte di provenienza e tipologia dati personali oggetto di trattamento</h3>
  <p>I dati personali raccolti sono forniti da Tempo 2050 S.r.l., previa raccolta del consenso dell’interessato alla
    loro comunicazione a partner promotori di specifiche iniziative riguardanti l’App, e sono i seguenti</p>
  <ul>
    <li>Identificativi (nome, cognome, codice fiscale)</li>
    <li>di contatto (indirizzo di posta elettronica)</li>
    <li>numero iscrizione ad ordini professionali (qualora necessario per talune categorie di utenti)</li>
  </ul>

  <h3>2. Finalità del trattamento</h3>
  <ul class="no-dots">
    <li><strong>2.1</strong> consentirle in qualità di utente registrato all’App, di utilizzare i servizi di 2° livello
      dell’applicazione da noi forniti</li>
    <li><strong>2.2</strong> condividere con gli altri utenti presenti sul segmento di interesse prescelto, le
      informazioni che la riguardano e partecipare alle attività proposte</li>
    <li><strong>2.3</strong> effettuare sulla base del consenso da lei manifestato una profilazione dei suoi dati
      personali, interessi e gradimenti</li>
    <li><strong>2.4</strong> consentire al titolare di inviare, sulla base del legittimo interesse e con modalità
      automatizzate di contatto (e-mail), comunicazioni promozionali e commerciali relative a servizi analoghi a quelli
      ai quali ha manifestato interesse, salvo il diritto di opporsi, sia immediatamente che successivamente, alla
      ricezione di tali comunicazioni o alle richieste di manifestazione del proprio grado di soddisfazione</li>
    <li><strong>2.5</strong> adempiere ad eventuali obblighi previsti dalle leggi vigenti, da regolamenti o dalla
      normativa comunitaria, o soddisfare richieste provenienti dalle autorità</li>
  </ul>

  <h3>3. Base giuridica del trattamento e facoltatività del conferimento dei dati</h3>
  <p>I trattamenti per le finalità precedentemente descritte si basano su:</p>
  <ul>
    <li>Finalità di cui ai punti 2.1 e 2.2, relativa base giuridica è l’art. 6(1)(b) del GDPR “([…] il trattamento è
      necessario all'esecuzione di un contratto di cui l'interessato è parte o all'esecuzione di misure precontrattuali
      adottate su richiesta dello stesso”; il conferimento dei dati personali per tali finalità è facoltativo, ma
      l'eventuale mancato conferimento comporterebbe l'impossibilità di attivare i servizi richiesti o concordati.</li>

    <li>Finalità di cui ai punti 2.3 la relativa base giuridica è il rilascio del suo consenso ai sensi dell’art.
      6(1)(a) “([…] l'interessato ha espresso il consenso al trattamento dei propri dati personali per una o più
      specifiche finalità)” del Regolamento. Il conferimento dei Suoi dati personali per queste finalità è quindi del
      tutto facoltativo. Qualora desiderasse revocare il consenso al trattamento dei suoi dati per tali finalità, potrà
      in qualunque momento farlo contattando il Titolare ai recapiti di seguito indicati nella presente informativa,
      senza con ciò pregiudicare la fruizione dei restanti servizi basati su differente base giuridica. La revoca del
      consenso non pregiudica la liceità del trattamento basata sul consenso prima della revoca.</li>

    <li>Finalità di cui al punto 2.4 la relativa base giuridica è l’art. 6(1)(f) del GDPR “([…] il trattamento è
      necessario per il perseguimento del legittimo interesse del titolare del trattamento o di terzi, a condizione che
      non prevalgano gli interessi o i diritti e le libertà fondamentali dell'interessato che richiedono la protezione
      dei dati personali, in particolare se l'interessato è un minore)”; per i trattamenti operati per tali finalità e
      con tale base giuridica l’interessato può esercitare il diritto di opposizione.</li>

    <li>Finalità di cui al punto 2.5, la relativa base giuridica è l’art. 6(1)(c) del GDPR “([…]il trattamento è
      necessario per adempiere un obbligo legale al quale è soggetto il titolare del trattamento)”; una volta conferiti
      i dati personali, il trattamento è invero necessario per adempiere ad obblighi di legge a cui il Titolare è
      soggetto.</li>
  </ul>

  <h3>4. Modalità di trattamento dei dati</h3>
  <p>I dati personali, ivi incluso le immagini fotografiche (se conferite), formeranno oggetto di operazioni di
    trattamento nel rispetto della vigente normativa e dei principi di correttezza, liceità, trasparenza e riservatezza
    cui è ispirata l'attività del Titolare. Tali dati verranno trattati sia con strumenti informatici sia su supporti
    cartacei sia su ogni altro tipo di supporto idoneo, nel rispetto delle misure di sicurezza previste dal GDPR.
    Si evidenzia che le modalità di trattamento attuate dal Titolare non implicano la necessità di sottoporre
    l’interessato ad una decisione, che possa includere una misura, che valuti aspetti di carattere personale che lo
    riguardano, che sia basata unicamente su un trattamento automatizzato e che produca effetti giuridici che lo
    riguardano o incida in modo analogo significativamente sulla sua persona, senza interventi umani. Nel caso in cui
    l’interessato ritenga che ciò possa essere avvenuto, può richiedere l’intervento umano per una rivalutazione del
    processo che lo riguarda.</p>


  <h3>5. Ambito di comunicazione dei dati</h3>
  <p>I dati personali potranno essere comunicati, nei limiti strettamente pertinenti alle finalità suindicate, anche
    soggetti terzi quali collaboratori, aziende partner o altri soggetti per fini strettamente legati alla gestione del
    servizio richiesto. In mancanza delle comunicazioni suddette le finalità indicate potrebbero non essere
    compiutamente adempiute. Gli autorizzati, nonché i responsabili e al trattamento dei dati sono puntualmente
    individuati e debitamente nominati e potranno essere da lei richiesti al Titolare nel caso in cui dovesse essere suo
    interesse conoscerne i dettagli.
    Di seguito le indichiamo le categorie dei soggetti con cui i suoi dati personali potranno essere condivisi, per le
    finalità riportate nella specifica sezione della presente informativa:</p>

  <ul>
    <li>soggetti che agiscono tipicamente in qualità di responsabili del trattamento, ossia:</li>
    <ul>
      <li>Tempo 2050 S.r.l. per l’attività di supporto e manutenzione dell’App Tempo</li>
      <li>Canale: {{group.legal_name}}</li>
    </ul>
  </ul>

  <p>(collettivamente “Destinatari”) i quali operano in qualità di responsabile del trattamento in virtù di specifico
    contratto per il trattamento dei dati stipulato ai sensi dell’art. 28 del Regolamento.</p>


  <h3>6. Diffusione dei dati</h3>
  <p>I dati personali non saranno oggetto di diffusione. Nei limiti pertinenti e strettamente connessi con le Aree di
    affiliazione prescelte, potranno essere diffusi tra i soggetti partecipanti all’ambito di appartenenza per le
    finalità strettamente correlate ai servizi erogati.</p>


  <h3>7. Diritti dell’interessato</h3>
  <p>Le ricordiamo che in qualunque momento lei ha diritto di conoscere quali siano i suoi dati personali in nostro
    possesso ed i relativi trattamenti in corso, di richiederne l’aggiornamento o la rettifica nonché, nei casi previsti
    dalla normativa vigente, di ottenerne la cancellazione, la limitazione del trattamento o di opporsi al loro
    trattamento. Se lo desidera potrà, inoltre, ricevere i suoi dati personali in formato elettronico al fine di un loro
    trasferimento ad un soggetto terzo da lei indicato. Nel caso in cui il trattamento si basi sul suo consenso
    esplicito, lei potrà in ogni momento revocare tale consenso.
    Le rammentiamo, infine, che in qualunque momento può decidere di proporre reclamo all’Autorità di controllo in caso
    di violazione della disciplina in materia di protezione dei dati personali e/o qualora ritenga che siano stati
    violati uno o più dei suoi diritti.</p>

  <p>Tali diritti potranno essere esercitati mediante semplice comunicazione scritta da inviarsi al Titolare del
    trattamento, all’indirizzo di posta elettronica indicato nella sezione contatti
    Potrà, inoltre, rivolgersi al Titolare per ricevere ulteriori informazioni o chiarimenti o per avere indicazione dei
    soggetti autorizzati ad accedere ai suoi dati personali.
    La modulistica per l’esercizio dei suoi diritti è reperibile al seguente link: <a href="https://www.garanteprivacy.it/web/guest/home/docweb/-/docweb-display/docweb/1089924">www.garanteprivacy.it/web/guest/home/docweb/-/docweb-display/docweb/1089924</a></p>



    <h3>8. Titolare del trattamento e contatti</h3>
    <p>Il titolare del trattamento è:</p>
    <p><strong>{{group.legal_name}}</strong> - C.F. {{group.fiscal_code}}, che può essere contattato nei seguenti modi:</p>
    <ul>
      <li>indirizzo postale: {{group.address_contact}}</li>
      <li>email: {{group.email_contact}}</li>
    </ul>

  </div>
    

</ion-content>

<ion-footer *ngIf="mandatoryRead">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="modalController.dismiss({mandatoryRead:true})">HO LETTO TUTTO, CHIUDI</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>